const en = {
  'n.comments.1': '{qty} comment',
  'n.comments.other': '{qty} comments',
  'n.reactions.1': '{qty} reaction',
  'n.reactions.other': '{qty} reactions',
};

export default en;
